module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('a', {
    attrs: {
      "id": "chapter1"
    }
  }), _vm._v("MARY JO BANG")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "sec2"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("FROM")]), _vm._v(" "), _c('em', [_vm._v("The Eye Like a Strange Balloon")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "sec3"
    }
  }), _vm._v("High Art")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("There’s a city outside"), _c('br'), _vm._v("the mind. Another inside."), _c('br'), _vm._v("A mind full of something"), _c('br'), _vm._v("becoming because."), _c('br'), _vm._v("A face too small for this red mouth. Look how")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("the line isn’t a street anymore"), _c('br'), _vm._v("but a track. Like that. The graveled"), _c('br'), _vm._v("shroud of a train. I’m not usually like"), _c('br'), _vm._v("this. A linkable Like arrives without its What."), _c('br'), _vm._v("Parks the car.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I remember the camera."), _c('br'), _vm._v("The clear click. The clean cutting off"), _c('br'), _vm._v("of the instant. Good-bye, good-bye."), _c('br'), _vm._v("The slide in the sleeve."), _c('br'), _vm._v("This opening eye. Wanting to take")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("everything in, sequence after sequence."), _c('br'), _vm._v("The framed now that never ends ending;"), _c('br'), _vm._v("the blue suit pulled from a pool"), _c('br'), _vm._v("of aqua dreaming."), _c('br'), _vm._v("Not knowing why aside")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._v("from theory. Sexual configurations"), _c('br'), _vm._v("of glamour. What is the scene?"), _c('br'), _vm._v("What is the cover? The frozen waiting"), _c('br'), _vm._v("for focus and drive."), _c('br'), _vm._v("Look, look, look. Art is what")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("looking takes you to. A red mouth"), _c('br'), _vm._v("opening to say,"), _c('br'), _vm._v("Don’t look away."), _c('br'), _vm._v("I’m not usually like this."), _c('br'), _vm._v("The camera sliding by with its aperture")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("open. Form, repetition, constructs,"), _c('br'), _vm._v("content, it happens. Here is the needle"), _c('br'), _vm._v("that speeds the plot to the ambush."), _c('br'), _vm._v("It happens. The Whole Truth shading desire."), _c('br'), _vm._v("Atmospherics predominating")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("over drama. Chiaroscuro focused"), _c('br'), _vm._v("on a point of desperation."), _c('br'), _vm._v("The recurrent dream of a catalog"), _c('br'), _vm._v("of surprise revelations."), _c('br'), _vm._v("Having makes wanting")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("continue a darkness both familiar"), _c('br'), _vm._v("and strange."), _c('br'), _vm._v("“What have you got there?”"), _c('br'), _vm._v("“A translation of a story of a dream"), _c('br'), _vm._v("world.” The sequence of events exists.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Here, one; here two;"), _c('br'), _vm._v("here, buckle; here shoe."), _c('br'), _vm._v("Now let there be sound."), _c('br'), _vm._v("Now let there be light."), _c('br'), _vm._v("Once there was this now.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5739cb62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter1.vue
// module id = 84
// module chunks = 0